import React, { useEffect, useState, useContext } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import Layout from '../../../parts/Layout';
import { httpRequest } from '../../../../services/httpService';
import helpers from '../../../../services/helpers';
import Loader from '../../../parts/Loader';
import CategoryFormModal from '../../../modals/CategoryFormModal';
import initTreeView from '../../../../services/initTreeView';
import MasterSchedulesForm from './MasterSchedulesForm';
import ShipsFormModal from '../ships/ShipsFormModal';
import ProfileContext from '../../../../services/profileContext';
import Swal from 'sweetalert2';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import Dropdown from 'react-bootstrap/Dropdown'
 
export default function MasterSchedulesList ({viewer = 'admin', home_page = "master-schedules"}){
    const {
        account
    } = useContext(ProfileContext);
    const { contact_id } = useParams();
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [search_key, setSearchKey] = useState('');
    const [master_schedule_id, setMasterScheduleID] = useState('');
    const [show_modal, setShowModal] = useState(0);
    const [show_ship_modal, setShowShipModal] = useState(0);

    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });

    const [page_title, setPageTitle] = useState('Manage Master Schedules');
    const [menu, setMenu] = useState('manage-master-schedules');
    const [selected_member_data, setMemberData] = useState('');
    const [selected_member_id, setMemberID] = useState('');
    const [selected_member_index, setMemberIndex] = useState('');
    const [ship_id, setShipID] = useState('');

    useEffect(() => {
        initTreeView()
        
        if(contact_id){
            setPageTitle('Customer Owned Master Schedules')
            setMenu('manage-customers')
        }

        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows
        })
    }, []);

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all
    ]);

    useEffect(() => {
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows,
            "search": search_key
        })
    }, [datatable_state]);

    function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        const page = datatable_state.page
        const per_page = datatable_state.rows
        const search = search_key
        let filter = `?paginate=1&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }
        if(contact_id){
            filter += 'customer_id='+contact_id+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        const url = helpers.createShipBookingHubUrl('master-schedules'+filter)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setRecordData(res)
                setLoading(0)
                displayDataTable(res)
            })
            .catch((err) => {
                //console.log(err)
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }
    
    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-delete'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Delete Master Schedule'
        if(ids.length > 1){
            title = 'Delete Categories'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                deleteItem(ids)
            }
        })
    }

    function deleteItem(id){
        const url = helpers.createShipBookingHubUrl('master-schedules/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "ids": id
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function formatDuration(duration_minutes){
        const hours = Math.floor(duration_minutes / 60);
        const mins = duration_minutes % 60;
        
        // Returns format: "2h 10m"
        return `${hours}h ${mins}m`;
    }

    function addMinutesAndFormat(startTime, durationMinutes) {
        // 1. Parse the "19:00:00" string
        const [hours, minutes, seconds] = startTime.split(':');
        const date = new Date();
        date.setHours(hours, minutes, seconds);

        // 2. Add the duration
        date.setMinutes(date.getMinutes() + parseInt(durationMinutes));

        // 3. Format to "07:00PM"
        return new Intl.DateTimeFormat('en-US', {
            hour: '2-digit',   // Ensures leading zero (e.g., "03")
            minute: '2-digit', // Ensures minutes are shown (e.g., ":00")
            hour12: true       // Uses AM/PM
        }).format(date).replace(/\s+/g, ''); // Removes the space before AM/PM
    }

    function getActiveDays(schedule) {
        const dayKeys = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
        
        return dayKeys
            .filter(day => schedule[day] === 1) // Check if the day is set to 1
            .map(day => day.toUpperCase())     // Convert to MON, WED, etc.
            .join(', ');                        // Combine into one string
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="normal"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column 
                    field="ship_name" 
                    header="Default Ship" 
                    body={({ship_name, default_ship_id})=> <button type="button" className='btn btn-sm btn-outline-secondary' onClick={() => {
                        setShipID(default_ship_id)
                        setShowShipModal(1)
                    }}>{ship_name}</button>}
                    style={{ minWidth: '150px' }}
                />
                <Column field="voyage_prefix" header="Voyage Prefix" />
                <Column 
                    field="origin" 
                    header="Origin" 
                    body={({origin})=> origin ? origin:'---'}
                />
                <Column 
                    field="destination" 
                    header="Destination" 
                    body={({destination})=> destination ? destination:'---'}
                />
                <Column 
                    field="departure_time" 
                    header="Departure Time" 
                    body={({departure_time})=> helpers.formatToTwelveHour(departure_time)}
                />
                <Column 
                    header="Arrival Time" 
                    body={({departure_time, duration_minutes})=> addMinutesAndFormat(departure_time, duration_minutes)}
                />
                <Column 
                    field="duration_minutes" 
                    header="Duration" 
                    body={({duration_minutes})=> formatDuration(duration_minutes)}
                />
                <Column 
                    header="Schedules" 
                    body={(schedule)=> getActiveDays(schedule)}
                />
                {/* <Column 
                    field="height" 
                    header="Height" 
                    body={({height})=> height ? height : '---'}
                />
                <Column 
                    field="weight" 
                    header="Weight" 
                    body={({weight})=> weight ? weight : '---'}
                />
                <Column 
                    header="Customer/Owner" 
                    body={({customer_id, customer_name})=> <Link to={`/customers/${customer_id}/edit`}>{customer_name}</Link>}
                />
                <Column 
                    field="driver" 
                    header="Driver" 
                    body={({driver})=> driver ? driver:'---'}
                /> */}
                <Column className="text-right" body={displayActionMenu} style={{ maxWidth: '100px' }}></Column> 
            </DataTable>
        )

    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        return (<Dropdown>
                        <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                        <Dropdown.Menu align="end">
                            <Dropdown.Item 
                                key="edit" 
                                onClick={(e) => editForm(data.id)}
                                className={helpers.checkPermissions(['superAdmin', 'masterScheduleEdit'], account?.permissions) ? 'text-dark' : 'secondary'}
                                disabled={!helpers.checkPermissions(['superAdmin', 'masterScheduleEdit'], account?.permissions)}
                            ><i className="fas fa-pencil-alt mr-2" />Edit</Dropdown.Item>
                            <Dropdown.Divider />
                            <Dropdown.Item 
                                key="delete" 
                                className={helpers.checkPermissions(['superAdmin', 'masterScheduleDelete'], account?.permissions) ? 'text-danger' : 'text-secondary'}
                                disabled={!helpers.checkPermissions(['superAdmin', 'masterScheduleDelete'], account?.permissions)}
                                onClick={(e) => triggerAction(data, 'single-delete')}
                            ><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>)
    }
    
    function addForm(e){
        setMasterScheduleID('')
        setShowModal(1)
    }
    function editForm(id){
        setShowModal(1)
        setMasterScheduleID(id)
    }

    function handleSave(){
        fetchDataList()
    }

    function handleShipSave(){
        fetchDataList()
    }

    return (
        <>
        
        <MasterSchedulesForm 
            is_show={show_modal} 
            setShow={setShowModal} 
            handleSave={handleSave} 
            reference_id={master_schedule_id}
            customer_id={contact_id}
        />

        
        <ShipsFormModal 
            is_show={show_ship_modal} 
            setShow={setShowShipModal} 
            handleSave={handleShipSave} 
            reference_id={ship_id}
        />
        
        <Layout page_title={page_title} menu={menu}>

            <div className="container-fluid" style={{position: 'relative'}}>
                <Loader isLoading={loading}/>
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header border-bottom-0">
                                <div className="row">
                                    <div className="col-lg-3">
                                        <InputText className="w-100" placeholder="Search Master Shedule" onChange={search} />
                                    </div>
                                    <div className="col-lg-9  d-flex align-items-center justify-content-end">
                                        <div className='d-flex justify-content-end py-2'>
                                            {selected_items.length ?
                                            <Dropdown className='mr-3'>
                                                <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                                <Dropdown.Menu align="end">
                                                    <Dropdown.Item 
                                                        key="delete" 
                                                        className={helpers.checkPermissions(['superAdmin', 'masterScheduleDelete'], account?.permissions) ? 'text-danger' : 'text-secondary'}
                                                        disabled={!helpers.checkPermissions(['superAdmin', 'masterScheduleDelete'], account?.permissions)}
                                                        onClick={(e) => triggerAction(selected_items)}
                                                    ><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown> : ''}
                                            <button type='button' className='btn btn-primary float-rights' onClick={addForm} disabled={!helpers.checkPermissions(['superAdmin', 'masterScheduleCreate'], account?.permissions)}><i className="fas fa-plus-circle mr-2" />New</button>

                                            {
                                                contact_id ?
                                                <Link className='btn btn-dark ml-3' to="/customers/list"><i class="right fas fa-angle-left mr-2"></i> Customer List</Link> : ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body p-0">
                                { data_table }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
        </>
    )
}